export default "/images/vendor/flag-icons/flags/1x1/ax.svg?3882371f1dbfb17cb5a63516a41851d0";